(function () {
  angular.module("akitabox.building.detail").run(states);

  /** @ngInject */
  function states(Router) {
    Router.configureStates([
      {
        state: "app.building.detail",
        config: {
          url: "",
          templateUrl: "app/mobile/modules/building/detail/detail.html",
          controller: "BuildingDetailController",
          controllerAs: "vm",
          bindToController: true,
          data: {
            pageTitle: "Building Info",
          },
        },
      },
    ]);
  }
})();
